import React, { Component } from 'react';
import '../assets/css/reset.css'
import '../assets/css/App.css'
import Header from './Header';
import CodeVerification from './CodeVerification.js'
import CustomerDisplay from './CustomerPortal.js'
import Footer from './Footer';
import SpinnerLoad from './SpinnerLoad';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import InternalServerError from './InternalServerError'
import { useNavigate } from 'react-router-dom'

class OTPVerify extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      CustomerReqId:'',
      showVerifyComponent: false,
      customerEmail: '',
      timeStamp:'',
      CustomerDisplay:'',
      clientToken: '',
      otpExpiration: '',
      seconds: '',
      encryptedReqId:'',
      internalServerError: false
    };
    this._onButtonClick = this._onButtonClick.bind(this);
    this.onParentCall = this.onParentCall.bind(this);
  }

  componentDidMount(){
    this.onDecryptReqID();
  }

  async onDecryptReqID() {
    var urlParams = new URLSearchParams(window.location.search);
    var requestId=urlParams.get('requestId').replace(/ /g,"+");
    let iterations = 128;
    let bytes = CryptoJS.PBKDF2(this.props.password, this.props.salt, { keySize: 48, iterations: iterations, hasher: CryptoJS.algo.SHA1 });
    let iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    let key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
    var ciphertext = CryptoJS.enc.Base64.parse(requestId);
    var decrypted = CryptoJS.AES.decrypt({ciphertext: ciphertext}, key, {
      iv: iv
    });
    this.setState({
      encryptedReqId:requestId,
      CustomerReqId:decrypted.toString(CryptoJS.enc.Utf8)
    }); 
    this.verifyRequestID();
  }

  verifyRequestID() {
    if(window.localStorage.getItem('requestID') === null){
      if(window.localStorage.getItem('entryCount') === null ||
        window.localStorage.getItem('entryCount') < window.localStorage.getItem('entryLimit')) {
          this.fetchClientToken();
      }
      else
      this.setState({showVerifyComponent:true})
    }
    else {
      if(window.localStorage.getItem('requestID') === this.state.CustomerReqId){
        this.props.navigate('/customer-portal');
      }
      else {
        window.localStorage.clear();
        this.fetchClientToken();
      }
    }
  }

  async fetchClientToken() {
    var encrypt_access_token = CryptoJS.AES.encrypt(this.props.access_token,process.env.REACT_APP_DPR_KVAULT_ENCRYPT).toString();
    var obj = { "access_token": encrypt_access_token, "client_id": "REACT_APP_AT_CLIENT_TOKEN", "request_var": "clientToken" };
    try {
      const response = await axios({
        url: 'clientid/keyvault',
        method: 'POST',
        data: obj
      })
      let bytes = CryptoJS.AES.decrypt(response.data,process.env.REACT_APP_DPR_KVAULT_ENCRYPT);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ clientToken: decryptRes })
      this.onGenerateOTP(this.state.CustomerReqId);
    }
    catch (e) {
      console.log(e);
    }
  }

  async onGenerateOTP(requestId) {
    var body = {
      "requestId": requestId,
      "clientName": "Customer_portal",
      "clientToken": this.state.clientToken,
    }
    var obj = { "url": process.env.REACT_APP_DPR_API_URL+"/GenerateOTP",
                "method":'POST',
              "body": CryptoJS.AES.encrypt(JSON.stringify(body), this.props.password).toString()
              };
    try {
      const response = await axios({
      url: '/servercall/DPRAPI',
      method: 'POST',
      data: obj
      })

      let bytes = CryptoJS.AES.decrypt(response.data,this.props.password);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if(decryptRes.status !== undefined && decryptRes.status.includes('Invalid')) {
        this.setState({ internalServerError: true });
      }
      if (decryptRes.status === 500 || (decryptRes.fault!==undefined && decryptRes.fault.faultstring.includes('unavailable'))) {
        this.setState({ internalServerError: true });
      }
      else{
        this.setState({
          showVerifyComponent: true,
          customerEmail: decryptRes.email_id,
          timeStamp: decryptRes.otp_dttm,
          otpExpiration: decryptRes.otp_exp
        })
        window.localStorage.setItem('customerEmail',decryptRes.email_id)
        window.localStorage.setItem('otpExpiration',decryptRes.otp_exp)
      }
    }
    
    catch(e) {
      console.log(e);
      this.setState({ internalServerError: true });
      return e;
    } 
  }

  _onButtonClick() {
    this.fetchClientToken();
  }

  onParentCall() {
    window.localStorage.setItem('encryptedReqId',this.state.encryptedReqId)
    window.localStorage.setItem('requestID',this.state.CustomerReqId)
    this.setState({
      showVerifyComponent: ! this.state.showVerifyComponent,
    });
    this.props.navigate('/customer-portal');
  }

  onAccountLock() {
    window.localStorage.setItem('unlock_timer',600)
  }
  
  render() {
    return (
      <div className="App">
        <Header />
        {this.state.showVerifyComponent ?
          <CodeVerification 
            onParentCall={this.onParentCall} 
            _onButtonClick= {this._onButtonClick}
            customerEmail={this.state.customerEmail} 
            timeStamp = {this.state.timeStamp} 
            CustomerReqId = {this.state.CustomerReqId} 
            otpExpiration = {this.state.otpExpiration}
            clientToken = {this.state.clientToken} 
            onAccountLock = {this.onAccountLock}
            password = {this.props.password }
          /> : 
          this.state.internalServerError ?
          <InternalServerError/> :
          <SpinnerLoad />
        }
        <Footer/>
      </div>
    );
  }
}

function OTPVerifyWrapper(props) {
  const navigate = useNavigate();
  return <OTPVerify {...props} navigate={navigate} />;
}

export default OTPVerifyWrapper;
